export { default } from './InternalAdminsTableFooter';
